<template>
  <div>
    <div :class="{ 'hdg-page-01': true, 'mb-03': !option.showLink }">
      <h1>{{ option.titlePage }}</h1>
      <ul class="link-txt-01 col left mb-00">
        <li v-if="option.showDetail" class="mb-00">
          <a href="" @click.prevent="openDialogServiceDetail" target="_blank"
            >{{ $t("KYG000000.label.service_detail") }}
            <img
              class="icn"
              src="@/assets/images/icn-blank-01.png"
              :alt="open_new_tab"
          /></a>
        </li>
        <template v-if="option.isImportExData || option.isImportExMaster">
          <li>
            <a
              href=""
              @click.prevent="openDialogDataExchangeTerms"
              target="_blank"
              >{{ $t("KYG000000.label.data_exchange_terms") }}
              <img
                class="icn"
                src="@/assets/images/icn-blank-01.png"
                :alt="open_new_tab"
            /></a>
          </li>
          <li>
            <a href="" @click.prevent="openDialogCountryCd" target="_blank"
              >{{ $t("KYG000000.label.counrty_cd") }}
              <img
                class="icn"
                src="@/assets/images/icn-blank-01.png"
                :alt="open_new_tab"
            /></a>
          </li>
          <li>
            <a href="" @click.prevent="openDialogStateCd" target="_blank"
              >{{ $t("KYG000000.label.state_cd") }}
              <img
                class="icn"
                src="@/assets/images/icn-blank-01.png"
                :alt="open_new_tab"
            /></a>
          </li>
          <li>
            <a href="" @click.prevent="openDialogTaxId" target="_blank"
              >{{ $t("KYG000000.label.tax_id") }}
              <img
                class="icn"
                src="@/assets/images/icn-blank-01.png"
                :alt="open_new_tab"
            /></a>
          </li>
        </template>
      </ul>
      <p class="link-btn-02 is-back" v-if="option.isBackToTopMenu">
        <a href="" @click.prevent="backToTopMenu">
          <span>{{ $t("KYG000000.label.to_main_menu") }}</span>
        </a>
      </p>
      <p class="link-btn-02 is-back" v-if="option.isBackToIssueMenu">
        <a href="" @click.prevent="backToIssueMenu">
          <span>{{ $t("KYG000000.label.go_to_shipping_menu") }}</span>
        </a>
      </p>
      <p class="link-btn-02 is-back" v-if="option.isBackToMainMenu">
        <a href="" @click.prevent="backToMainMenu">
          <span>{{ $t("KYG000000.label.to_ybm_main_menu") }}</span>
        </a>
      </p>
      <!-- /.hdg-page-01 -->
    </div>

    <ul class="link-txt-01 col right mb-02" v-if="option.showLink" href="">
      <li>
        <a href="" @click.stop.prevent="openWindowServiceGuide" target="_blank">
          {{ $t("KYG002001.label.operation_guide") }}
          <img
            class="icn"
            src="@/assets/images/icn-blank-01.png"
            :alt="$t('KYG002001.label.open_new_tab')"
          />
        </a>
      </li>
      <li>
        <a href="" @click.stop.prevent="openWindowServiceTerms" target="_blank">
          {{ $t("KYG002001.label.terms") }}
          <img
            class="icn"
            src="@/assets/images/icn-blank-01.png"
            :alt="$t('KYG002001.label.open_new_tab')"
        /></a>
      </li>
      <li>
        <a href="" @click.stop.prevent="openModalEnvironment" target="_blank">
          {{ $t("KYG002001.label.note") }}
          <img
            class="icn"
            src="@/assets/images/icn-blank-01.png"
            :alt="$t('KYG002001.label.open_new_tab')"
        /></a>
      </li>
    </ul>

    <ol class="list-step-01" v-if="option.showStep">
      <li v-for="step in option.listSteps" :key="step.id">
        <b v-if="step.status === 2">{{ step.name }}</b>
        <span v-if="step.status === 1">{{ step.name }}</span>
      </li>
    </ol>
  </div>
</template>

<script>
import Url from "@/constants/url-const";
import CommonService from "@/core/utils/common-service";

const size =
  "top=0,left=0,width=750, height=600, scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1";

const backConfirm = "Message.BackConfirm";

export default {
  name: "HeaderBody",
  data() {
    return {
      open_new_tab: this.$t("KYG000000.label.open_new_tab"),
      url: Url
    };
  },

  props: {
    option: {
      listSteps: Array,
      showStep: Boolean,
      titlePage: String,
      isBackToMainMenu: Boolean,
      isBackToIssueMenu: Boolean,
      showDetail: Boolean,
      showLink: Boolean,
      isImportExData: Boolean,
      isImportExMaster: Boolean
    }
  },
  methods: {
    // 「ワールドポータルTOPへ」押下時
    backToTopMenu: function() {
      CommonService.showDialogConfirm(
        this.$bvModal,
        this.$createElement,
        this.$t(backConfirm, {
          0: this.$t("KYG000000.label.world_portal_top")
        })
      ).then(isBackTopMenu => {
        if (isBackTopMenu) {
          this.$router.push({
            name: "Menu"
          });
        }
      });
    },
    // 「メインメニューへ」押下時
    backToMainMenu: function() {
      CommonService.showDialogConfirm(
        this.$bvModal,
        this.$createElement,
        this.$t(backConfirm, {
          0: this.$t("KYG000000.label.breadcrumb_topmenu")
        })
      ).then(isBackMainMenu => {
        if (isBackMainMenu) {
          location.href = Url.LINK_YMT_YBM_MAIN_MENU;
        }
      });
    },
    // 「送り状発行メニューへ」 押下時
    backToIssueMenu: function() {
      CommonService.showDialogConfirm(
        this.$bvModal,
        this.$createElement,
        this.$t(backConfirm, {
          0: this.$t("KYG000000.label.shipping_label_menu")
        })
      ).then(isBackIssueMenu => {
        if (isBackIssueMenu) {
          this.$router.push({
            name: "IssueMenu"
          });
        }
      });
    },
    //「詳細はこちら」押下時
    openDialogServiceDetail() {
      window.open(this.url.LINK_YMT_SERVICE_DETAIL, "blank", size);
    },
    //操作ガイドについてリンク押下
    openWindowServiceGuide() {
      window.open(this.url.LINK_YMT_SERVICE_GUIDE, "blank", size);
    },
    //お客様環境情報リンク押下
    openModalEnvironment() {
      this.$bvModal.show("environmentPopup");
    },
    //利用規約リンク押下
    openWindowServiceTerms() {
      window.open(this.url.LINK_YMT_TERMS_OF_SERVICE, "blank", size);
    },
    // データ交換規約押下時
    openDialogDataExchangeTerms() {
      if (this.option.isImportExData) {
        window.open(this.url.LINK_YMT_DATA_EXCHANGE_TERMS, "blank", size);
      } else {
        window.open(
          this.url.LINK_YMT_MASTER_DATA_EXCHANGE_TERMS,
          "blank",
          size
        );
      }
    },
    // 国コード押下時
    openDialogCountryCd() {
      window.open(this.url.LINK_YMT_COUNTRY_CD, "blank", size);
    },
    // 州コード押下時
    openDialogStateCd() {
      window.open(this.url.LINK_YMT_STATE_CD, "blank", size);
    },
    // Tax ID押下時
    openDialogTaxId() {
      window.open(this.url.LINK_YMT_TAX_ID, "blank", size);
    }
  }
};
</script>
